import React from 'react';

import { PostResponse } from '../../types/models/posts';
import { PostCard } from '../cards/PostCard/PostCard';
import { CardItemList } from './CardItemList/CardItemList';

interface IPostListProps {
  posts: PostResponse[];
  isCurrentUser?: boolean;
  isLanding?: boolean;
};

export function PostList({ posts, isCurrentUser, isLanding }: IPostListProps) {
  const postCardElements =
    posts.map((post: PostResponse) => {
      return <PostCard post={ post } isLanding={ isLanding } />;
    });
  return (
    <CardItemList items={ postCardElements } singleItemName='post' isCurrentUser={ isCurrentUser } />
  );
}
